<template>
  <div class="home_index">
    <van-sticky>
        <div class="home_header">
            <van-search
            v-model="keywords"
            show-action
            placeholder="请输入搜索关键词"
            @search="onSearch"
            >
                <template #action>
                    <div @click="onSearch">搜索</div>
                </template>
            </van-search>
            <van-dropdown-menu active-color="#1989fa">
                <!-- <van-dropdown-item get-container="body" title="区域筛选" @change="change" v-model="district" :options="dlist" /> -->
                <van-dropdown-item get-container="body" @change="change" v-model="month" :options="mlist" />
                <van-dropdown-item get-container="body" @change="change" v-model="match_plate_id" :options="plist" />
                <!-- <van-dropdown-item get-container="body" @change="change" v-model="state" :options="slist" /> -->
            </van-dropdown-menu>
        </div>
    </van-sticky>
        
    <div class="home_body">
        <List
            style="color:#FFF;"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="init"
            >
            <div class="rank-list">
                <div class="blist" v-for="(item,index) in matchlist" :key="index">
                    <div class="bitem">
                        <div class="bt">
                            <div class="icon">
                                <van-tag class="tag" :color="item.statecolor">{{item.statename}}</van-tag>
                                <van-image mode="aspectFit" :src="item.cover_url || item.imgurl" />
                            </div>
                            <div class="con">
                                <div class="btitle threeline">
                                    <van-image class="btab" :src="item.online_flag | filerstate" />
                                    <span>{{item.match_name}}</span>
                                </div>
                                <div class="btime">{{item.starttime}}-{{item.endtime}}</div>
                                <div class="btime">赛事编码：{{item.number}}</div>
                            </div>
                        </div>
                        <div class="bb">
                            <div class="btips">#{{item.match_level}} #{{item.match_plate}}</div>
                            <div class="btn disabled" v-if="item.evid">已填写</div>
                            <!-- <div class="btn disabled" v-else-if="item.statestatus"></div> -->
                            <div class="btn" @click="godetail(item)" v-else-if="item.statestatus">填写评估表</div>
                        </div>
                    </div>
                        
                    <div class="hr"></div>
                    <div class="hr"></div>
                </div>
            </div>
        </List>
    </div>
  </div>
</template>
<script>
    import "./index.less"
    import { Empty, Panel,  Cell, CellGroup, Image, Search,DropdownMenu, DropdownItem,List,Sticky,Tag } from "vant";
    import moment from 'moment';

    export default {
        name: 'homeIndex',
        data () {
            return {
                keywords: '',
                district: '0',
                match_plate_id: '0',
                month: '0',
                state: '0',
                dlist: [
                    {text: "全部区域", value: "0"},
                    {text: "静安区", value: "静安区"},
                    {text: "黄浦区", value: "黄浦区"},
                    {text: "徐汇区", value: "徐汇区"},
                    {text: "长宁区", value: "长宁区"},
                    {text: "虹口区", value: "虹口区"},
                    {text: "普陀区", value: "普陀区"},
                    {text: "闵行区", value: "闵行区"},
                    {text: "宝山区", value: "宝山区"},
                    {text: "杨浦区", value: "杨浦区"},
                    {text: "浦东新区", value: "浦东新区"},
                    {text: "松江区", value: "松江区"},
                    {text: "嘉定区", value: "嘉定区"},
                    {text: "青浦区", value: "青浦区"},
                    {text: "金山区", value: "金山区"},
                    {text: "奉贤区", value: "奉贤区"},
                    {text: "崇明区", value: "崇明区"}
                ],
                mlist: [
                    {text: "全部月份", value: "0"},
                    {text: "一月", value: "01"},
                    {text: "二月", value: "02"},
                    {text: "三月", value: "03"},
                    {text: "四月", value: "04"},
                    {text: "五月", value: "05"},
                    {text: "六月", value: "06"},
                    {text: "七月", value: "07"},
                    {text: "八月", value: "08"},
                    {text: "九月", value: "09"},
                    {text: "十月", value: "10"},
                    {text: "十一月", value: "11"},
                    {text: "十二月", value: "12"},
                ],
                slist: [
                    {text: "全部", value: "0"},
                    {text: "已评估", value: "1"},
                    {text: "暂存", value: "2"},
                ],
                plist: [],
                loading: false,
                finished: false,
                matchlist: [],
                page: 1
            }
        },
        filters: {
            filerstate(rank) {
                switch(rank){
                    case 'offline':
                        return "https://oss.mcloud.moveclub.cn/alphamovecloud/20230309/1678329502/347845.png";
                    case 'online':
                        return "https://oss.mcloud.moveclub.cn/alphamovecloud/20230309/1678329502/306697.png";
                    case 'offline,online':
                    case 'online,offline':
                        return "https://oss.mcloud.moveclub.cn/alphamovecloud/20230417/1681724490/291348.png";
                }
            } 
        },
        components:{
            VanImage: Image,
            Empty,
            Panel,
            Cell,
            CellGroup,
            VanSearch: Search,
            VanDropdownMenu: DropdownMenu,
            VanDropdownItem: DropdownItem,
            List,
            VanSticky: Sticky,
            VanTag: Tag
        },
        watch: {
        },
        methods: {
            godetail(item) {
                let params = {
                    matchid: item.id
                }
                this.$router.push({name:'joinMatch1',params})
            },
            change(value) {
                this.matchlist = []
                this.page = 1
                this.finished = false
                this.init()
            },
            onSearch() {
                this.matchlist = []
                this.page = 1
                this.finished = false
                this.init()
            },
            init: function () {
                let query = {
                    page: this.page,
                    keywords: this.keywords,
                    district: this.district,
                    month: this.month,
                    state: this.state,
                    match_plate_id: this.match_plate_id,
                    level: '市级'
                }
                this.$api.match.getlist(query).then(
                    (res) => {
                        if (!res.success) {
                            this.finished = true;
                            return;
                        }
                        this.systime = res.sys_time;
                        this.loading = false;
                        let {
                            list,
                            page,
                            platelist
                        } = res.data;
                        let arr = [{text:'全部板块',value:'0'}]
                        platelist.forEach(item=>{
                            arr.push({
                                text: item.match_plate,
                                value: item.match_plate_id
                            })
                        })
                        this.plist = arr
                        let system = res.sys_time
                        let now = moment(res.sys_time*1000).format("YYYY-MM-DD");
                        list.forEach(item=>{
                            item.statestatus = 0
                            item.starttime = moment(item.start_time*1000).format("YYYY-MM-DD");
                            item.endtime = moment(item.end_time*1000).format("YYYY-MM-DD");
                            if(system>=item.start_time*1 && system<= item.end_time*1) {
                                item.statename = '比赛中'
                                item.statecolor = '#F7B500'
                                item.statestatus = 1
                            } else if(system<item.start_time*1) {
                                item.statename = '未开始'
                                item.statecolor = '#646464'
                            } else if(system>item.end_time*1){
                                item.statename = '已结束'
                                item.statecolor = '#646464'
                            } else {
                                item.statename = '等待中'
                                item.statecolor = '#646464'
                            }

                            if(now==item.starttime || now==item.endtime){
                                item.statename = '比赛中'
                                item.statecolor = '#F7B500'
                                item.statestatus = 1
                            }
                        })
                        if (page.currentPage == 1) {
                            this.matchlist = list;
                        } else {
                            this.matchlist = this.matchlist.concat(list);
                        }
                        if (page.currentPage >= page.pageCount) {
                            this.finished = true;
                        } else {
                            this.page++;
                        }
                    }
                );
            },
        },     
        mounted() {
            this.$nextTick(() => {
                // this.init()
                // this.getflist()
            })

        }
    }
</script>

